export const TOGGLE_MODAL_ACTION = 'TOGGLE_MODAL_ACTION'
export const SET_MODAL_ACTION = 'SET_MODAL_ACTION'
export const TOGGLE_LOADING_MODAL_ACTION = 'TOGGLE_LOADING_MODAL_ACTION'
export const SET_DATA_MODAL_FORM_LIST = 'SET_DATA_MODAL_FORM_LIST'
